var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text && _vm.text.trim())?_c('div',{ref:"container",staticClass:"marquee-container"},[_c('div',{ref:"content",staticClass:"marquee-content",style:({ left: _vm.position + 'px' })},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c0d7539","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/workroomdp/components/Auotsrceen.vue
// module id = null
// module chunks = 